import styled from "@emotion/styled";
import tw from "twin.macro";

export const CountBadge = styled("span")(
  tw`bg-gray-200 group-hover:bg-gray-200 ml-auto inline-block py-0.5 px-3 text-xs font-medium rounded-full`
);
